import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BaseLayoutComponent } from './Layout/base-layout/base-layout.component';
import { PagesLayoutComponent } from './Layout/pages-layout/pages-layout.component';

// DEMO PAGES

// Dashboards

import { Home } from './Pages/home/home.component';

// Pages

import { ForgotPasswordBoxedComponent } from './Pages/forgot-password/forgot-password.component';
import { LoginBoxedComponent } from './Pages/login/login.component';
import { RegisterBoxedComponent } from './Pages/register/register.component';
import { FileComplainComponent } from './Portal/file-complain/file-complain.component';
import { EmergencyComponent } from './Portal/emergency-number/emergency.component';
import { ResourceComponent } from './Portal/resource-center/resource.component';

import { EmergencyService } from './Portal/emergency-number/emergency.service';
import { FileComplainService } from './Portal/file-complain/file-complain.service'
import { RegisterService } from './Pages/register/register-service.service';
import { MyComplainService } from './Portal/my-complains/my-complain.service';
import { RegularComponent } from './Portal/my-complains/my-complains.component';
import { ResourceService } from './Portal/resource-center/resource.service';
import { ComplainDetailComponent } from './Portal/complain-detail/complain-detail.component';
import { ComplaintDetailService } from './Portal/complain-detail/complaint-detail.service';
import { ForgotService } from './Pages/forgot-password/forgot-service.service';
import { ProfileService } from './Portal/profile/profile.service';
import { ProfileComponent } from './Portal/profile/profile.component';
import { CategoriesResourceComponent } from './Portal/resource-center/categoriesResourceCenter/categoriesResource.component'
import { CategoriesResourceService } from './Portal/resource-center/categoriesResourceCenter/categoriesResource.service';
import { UserService } from './Layout/Components/header/elements/user-box/users.service';


const routes: Routes = [
  {
    path: '',
    component: BaseLayoutComponent,
    children: [
      { path: '', component: Home, data: { extraParameter: 'dashboardsMenu' } },
      {
        path: 'file-complain',
        component: FileComplainComponent,
        data: { extraParameter: 'elementsMenu' },
        resolve: {
          data: FileComplainService
          // 
        }
      },
      {
        path: 'emergency-number',
        component: EmergencyComponent,
        data: { extraParameter: 'componentsMenu' },
        resolve: {
          data: EmergencyService
        }
      },
      { path: 'my-complains', 
      component: RegularComponent, 
      data: { extraParameter: 'formElementsMenu' },
      resolve: {
        data: MyComplainService
        // 
      }
    },
    { path: 'resource-center', 
      component: ResourceComponent, 
      data: { extraParameter: 'tablesMenu' },
      resolve: {
        data: ResourceService
        // 
      }
    },
    { path: 'complaint-detail/:id', 
      component: ComplainDetailComponent, 
      data: { extraParameter: 'formElementsMenu' },
      resolve: {
        data: ComplaintDetailService
      }
    },
    { path: 'resource/:id', 
      component: CategoriesResourceComponent, 
      data: { extraParameter: 'tablesMenu' },
      resolve: {
        data: CategoriesResourceService
      }
    },
    {
      path: 'profile',
      component: ProfileComponent,
      data: { extraParameter: 'formElementsMenu' },
      resolve: {
        data: ProfileService
      }
    },
    ]
  },
  {
    path: '',
    component: PagesLayoutComponent,
    children: [
      { path: 'login', component: LoginBoxedComponent, data: { extraParameter: '' } },
      { path: 'register', 
      component: RegisterBoxedComponent, 
      data: { extraParameter: '' },
      resolve: {
        data: RegisterService
        // 
      }
    },
      { path: 'forgot-password', 
      component: ForgotPasswordBoxedComponent, 
      data: { extraParameter: '' },
    
    resolve: {
      data: ForgotService
    }},
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    })],
  providers: [
    EmergencyService,
    FileComplainService,
    RegisterService,
    ProfileService,
    UserService
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
